export default __webpack_public_path__ + "static/media/cwTeXKai-zhonly.be8e47c2.ttf";